import type { ContentItem, EditorState } from "@smartsuite/smartdoc";
import type {
  ActionCandidate,
  TriggerCandidate,
} from "../../../../../../../../types/candidate";
import type {
  ValueConfig,
  ValueConfig_V,
} from "@smartsuite/automation-engine-api";

export const toValueConfig = (
  value: EditorState,
  trigger: TriggerCandidate,
  actions: ActionCandidate[],
): ValueConfig => {
  const json = value.toJSON();

  return {
    values: json.doc.content.flatMap(
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      (item: { [key: string]: any }) => {
        return (
          item.content?.reduce((acc: ContentItem[], item: ContentItem) => {
            if (item.type === "pill" && !item.attrs?.invalid) {
              const value = JSON.parse(String(item.attrs?.value));
              const valueV = getValue(value, trigger, actions);
              return [...acc, valueV];
            } else {
              return [...acc];
            }
          }, []) ?? []
        );
      },
    ),
  };
};

const getValue = (
  value: any,
  trigger: TriggerCandidate,
  actions: ActionCandidate[],
): ValueConfig_V => {
  switch (value.target) {
    case "action":
      return {
        value: {
          oneofKind: "reference",
          reference: {
            outputId: String(value.value),
            source: {
              oneofKind: "actionReference",
              // @ts-expect-error - actionReference is not undefined
              actionReference: actions.find(
                (action) => action.hash === value.hash,
              ),
            },
          },
        },
      };
    case "trigger":
      return {
        value: {
          oneofKind: "reference",
          reference: {
            outputId: String(value.value),
            source: {
              oneofKind: "triggerReference",
              // @ts-expect-error - triggerReference is not undefined
              triggerReference: trigger.triggerReference,
            },
          },
        },
      };
    default:
      return {
        value: {
          oneofKind: "reference",
          reference: value,
        },
      };
  }
};
